/**
 * Accordion
 * 
 * Usage: 
 * 
 * <div class="pr-accordion">
 *      <div id="acc-count{{dynamic number}}" class="pr-accordion-intro>">
 *         {{ Title }}
 *      </div>
 *      <div class="pr-accordion-content">
 *          {{ Content }}
 *      </div>
 * </div>
 * 
 * Styles: _accordion.scss
 * 
 */

let count = 0;
let isContentHub = false;
const accordions = document.querySelectorAll(".pr-accordion");
const mainFaq = document.querySelector('.faq-main');

/**
 * Accordion scroll
 * @param {string} el Accoridon element
 */
const accordionScroll = (el) => {
    el.preventDefault();

    if (el) {
        let element = document.getElementById(el);

        let offset = 56;

        if (document.querySelector('.product_showcase_panel') !== null) {
            offset = 0;
        }

        if (element) {
            const bodyRect = document.body.getBoundingClientRect().top;
            const elementRect = element.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });

            element = null;
        }
        el = null;
    }
};

/**
 * Open accordion
 * @param {string} accordion Accordion element
 * @param {string} val Accordion value
 * @param {string} accCountSelector Accordion count selector
 * @param {boolean} isContentHub Is content hub
 * @param {string} sidebarInitial Sidebar initial height
 * 
 */

const openAccordion = (accordion, val, accCountSelector, isContentHub) => {

    if (val) {
        const specifics = document.getElementsByClassName('pr-accordion open-all acc-val-' + val);

        for (let specific of specifics) {
            const content = specific.querySelector(".pr-accordion-content");
            specific.classList.add("pr-accordion-active");
            specific.classList.add('opened');
            content.style.maxHeight = content.scrollHeight + "px";
        };

    } else {
        const content = accordion.querySelector(".pr-accordion-content");
        const answer = accordion.querySelector('.answer');
        accordion.classList.add("pr-accordion-active");

        if (isContentHub == true) {
            const contents = document.querySelector('.bl-toc-transparent');
            const sideBar = document.querySelector('.toc-sidebar');

            sidebarInitial = contents.offsetHeight;
            sideBar.style.height = content.scrollHeight + contents + 'px';
            content.style.maxHeight = content.scrollHeight + "px";
        } else {
            content.style.maxHeight = content.scrollHeight + "px";
        }

        let el = accCountSelector;

        if (accCountSelector) {
            answer.addEventListener('transitionend', () => { // Wait for block to open before scrolling
                accCountSelector = null;
            });
        }
    }
}

/**
 * Close accordion
 * @param {string} accordion Accordion element
 * @param {string} val Accordion value
 */
const closeAccordion = (accordion, val) => {
    if (val) {
        const specifics = document.getElementsByClassName('pr-accordion open-all acc-val-' + val);

        for (let specific of specifics) {
            const content = specific.querySelector(".pr-accordion-content");
            specific.classList.remove("pr-accordion-active");
            specific.classList.remove('opened');
            content.style.maxHeight = null;
        }

    } else {
        accordion.classList.remove("pr-accordion-active");
        const content = accordion.querySelector(".pr-accordion-content");
        content.style.maxHeight = null;
    }
};


accordions.forEach((accordion) => {
    const intro = accordion.querySelector(".pr-accordion-intro");
    const content = accordion.querySelector(".pr-accordion-content");
    const qna = accordion.querySelector('.answer');
    const accVal = accordion.getAttribute('data-accval');
    const accCountSelector = 'acc-count' + count;

    let isContentHub = accordion.dataset.accordion;

    if (isContentHub === 'true') {
        isContentHub = true;
    } else {
        isContentHub = false;
    }

    intro.onclick = (e) => {

        e.preventDefault();

        if (content.style.maxHeight) {
            if (accordion.classList.contains('opened')) {
                accordion.classList.remove('opened');
                accordions.forEach((accordion) => closeAccordion(accordion, accVal))
            } else {
                closeAccordion(accordion);
            }
        } else {

            if (accordion.classList.contains('open-all')) {
                accordions.forEach((accordion) => openAccordion(accordion, accVal, null, isContentHub))
            } else {
                accordions.forEach((accordion) => closeAccordion(accordion, null, null, isContentHub));
            }

            if (qna) {
                // Main accordion
                openAccordion(accordion, null, accCountSelector, isContentHub);
            } else {
                openAccordion(accordion, null, null, isContentHub);
            }
        }
    };

    if (qna) {
        count++;
    }
});

/**
 * Accordion content height
 * @param {string} accContentHeight Accordion content height
*/

window.doAccordion = function (accContentHeight) {

    accordions.forEach((accordion) => {
        const content = accordion.querySelector(".pr-accordion-content");
        content.style.maxHeight = content.offsetHeight + accContentHeight + 40 + "px";
    });
}



